<template>
  <div class="comptador">
    <div class="counter">
      <span class="count">{{ count }}</span>
      <span class="total">/{{ displayTotal }}</span>
    </div>
    <span class="page-title">{{ $t(titleKey) }}</span>
    <span
      class="change-estimate"
      v-if="isPlayers"
      @click="handleChangeEstimate"
      ref="estimation-title"
    >
      {{ $t("params.change_estimation") }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'CounterDisplay',
  props: {
    count: { type: Number, required: true },
    total: { type: Number, required: false },
    titleKey: { type: String, required: true },
    isPlayers: { type: Boolean, default: false }
  },
  computed: {
    displayTotal () {
      return this.total || 0
    }
  },
  methods: {
    handleChangeEstimate () {
      this.$emit('change-estimate')
    }
  }
}
</script>

<style lang="scss" scoped>
.comptador {
  display: flex;
  align-items: flex-end;
  font-family: 'Arial', sans-serif;
  color: #000;
  gap: 8px;
}

.counter {
  display: flex;
  align-items: flex-end; // Aligns large and small numbers at their base
}

.count {
  font-size: 32px;
  font-weight: bold;
  line-height: 1;
}

.total {
  font-size: 18px;
  color: #555;
  margin-left: 2px;
  line-height: 1.2;
}

.page-title {
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.change-estimate {
  font-size: 14px;
  color: #172654;
  cursor: pointer;
  text-decoration: none;
  line-height: 1;

  &:hover {
    text-decoration: underline;
  }
}
.comptador {
  display: flex;
  align-items: flex-end;
  font-family: 'Arial', sans-serif;
  color: #000;
  gap: 8px;
}

.counter {
  display: flex;
  align-items: flex-end; // Aligns large and small numbers at their base
}

.count {
  font-size: 32px;
  font-weight: bold;
  line-height: 1;
}

.total {
  font-size: 18px;
  color: #555;
  margin-left: 2px;
  line-height: 1.2;
}

.page-title {
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.change-estimate {
  font-size: 14px;
  color: #172654;
  cursor: pointer;
  text-decoration: none;
  line-height: 1;

  &:hover {
    text-decoration: underline;
  }
}

</style>
